module.exports = __webpack_public_path__ + "img/link_1.d25f13e1.png";